<template app>
<div >

    <v-autocomplete
        :items="items"
        :label="filters.label"
        :item-text="filters.name"
        :item-value="filters.id"
        v-model="filters.default"
        height="30"
        cache-items
        chips
        dense
        outline
        small
        small-chips
        clearable
        deletable-chips
        multiple
        v-on:change ="triggerEvent"
      >
      </v-autocomplete>
    </div>
</template>

<script>
import DropDownModel from '@/api/service/DropDownService'

  export default {
   props: ["filters","selected"],
 
 data () {
      return {
          selectedId:"",
        items:[
          
        ],
        exclude:false,
        selectedId1:"",
        selectedText1:"",
        dialog:false
      }
    },
    created: function() {
        console.log(this.filters.source)
        if(this.filters.source=='dropdown') {
          this.items= this.filters.options
        } else {
        DropDownModel.getList({"model":this.filters.source})
        .then(response => {
            this.setItems(response)                
        }).catch(error => {
            console.log(error)
      });
        }
  },
  methods: {
      triggerEvent($v,$event) {
          var $json ={}
          if(this.exclude) {
            $v.splice(0,0,'!')
          }
         // $json[this.filters.filter_id]=$v;
          $json[this.filters.id]=$v;
          //alert($v)
          this.$emit('change',$json)
          this.selectedId=$v
          console.log($json)

      },
      setItems(items) {
            var $i=0;
          var $exclude ={}
          $exclude[this.filters.id]='!'
          $exclude[this.filters.name]='Exclude'
          this.items.push($exclude)
          for($i=0;$i<items.length;$i++) {
          this.items.push(items[$i]) 
      }
      }
      }
  }
</script>